import { SVGProps } from "react";

const WarningCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={30} cy={30} r={30} fill="#FFFAEE" />
    <path
      d="M29.9985 26.2501V31.2501M20.4722 33.9998C19.3354 35.9688 18.7671 36.9537 18.8521 37.7615C18.9261 38.4662 19.2959 39.1063 19.8691 39.5228C20.5261 40.0001 21.6622 40.0001 23.9342 40.0001H36.0629C38.3349 40.0001 39.4708 40.0001 40.1278 39.5228C40.701 39.1063 41.071 38.4662 41.145 37.7615C41.2299 36.9537 40.6619 35.9688 39.5251 33.9998L33.4629 23.4998C32.3261 21.5308 31.7575 20.5465 31.0154 20.2161C30.3681 19.928 29.6285 19.928 28.9813 20.2161C28.2395 20.5464 27.6712 21.5307 26.5354 23.4981L20.4722 33.9998ZM30.062 35.0001V35.1251L29.9363 35.1253V35.0001H30.062Z"
      stroke="#EDA900"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default WarningCircle;
